import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=848453aa&"
import script from "./Hospital.vue?vue&type=script&lang=ts&"
export * from "./Hospital.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848453aa')) {
      api.createRecord('848453aa', component.options)
    } else {
      api.reload('848453aa', component.options)
    }
    module.hot.accept("./Hospital.vue?vue&type=template&id=848453aa&", function () {
      api.rerender('848453aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/Hospital.vue"
export default component.exports